import { cn } from "@/lib/utils";

/** The kourai mark: a yellow square and the lowercase name, after geilo.co's small print. */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 text-[15px] font-medium tracking-[-0.02em] whitespace-nowrap",
        className,
      )}
    >
      <span aria-hidden="true" className="bg-highlight size-2.5" />
      kourai
    </span>
  );
}
